import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type GetPageBeginActionData, type GetPageSuccessActionData } from "./actions";
import { type Search } from "./types";

const reducer = (state: Search.AppState = defaultState, action: ReduxAction<any>): Search.AppState => {
  switch (action.type) {
    case Actions.GetPageBegin: {
      const { text } = action.data as GetPageBeginActionData;
      return {
        ...state,
        error: null,
        status: "Searching",
        text
      };
    }
    case Actions.GetPageFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        error,
        status: "Failed"
      };
    }
    case Actions.GetPageSuccess: {
      const { page } = action.params as GetPageBeginActionData;
      const { items, hasMore } = action.data as GetPageSuccessActionData;
      return {
        ...state,
        currentPage: page,
        items,
        status: "Ready",
        hasMore
      };
    }
    default:
      return state;
  }
};

export const defaultState: Search.AppState = {
  error: null,
  id: "",

  status: "None",

  text: "",

  currentPage: 0,
  items: [],
  hasMore: false
};
export const previewState: Search.AppState = {
  ...defaultState,
  status: "Ready",
  currentPage: 1,
  items: [
    {
      description: "Dummy",
      keywords: "Dummy",
      path: "/dummy",
      title: "Dummy"
    }
  ]
};
export default wrapReducer({ defaultState, reducer, previewState });
